var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF4D4F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 14.25a1.5 1.5 0 0 1-2.296 1.272l-3.001-1.876a1.5 1.5 0 0 1-.705-1.273V3.75a1.5 1.5 0 0 1 2.296-1.273l3 1.876A1.5 1.5 0 0 1 9 5.625z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF4D4F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15.002 7.156-2.186 2.187M15.002 9.343l-2.186-2.187M14.252 4.498v-.75a1.5 1.5 0 0 0-1.5-1.5H4.498M9 14.252h3.752a1.5 1.5 0 0 0 1.5-1.5V12"
  })));
};
export { SvgLogout as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMGYyZTBhMTBkZTg1MTI5NDNmYzdhMzJhOTcwYjlmYzguc3ZnIjs=";